export default __webpack_public_path__ + "static/media/undraw_Mobile_login_re_9ntv.c8d61989.svg";